var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHomeLight = function SvgHomeLight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 11,
    "data-width-24": 16,
    viewBox: "0 0 15.6 18",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.806 17.083a2.75 2.75 0 0 0 1.944.806h10a2.75 2.75 0 0 0 2.79-2.77v-8.08a2.73 2.73 0 0 0-1-2.08l-5-4.29a2.73 2.73 0 0 0-3.58 0l-5 4.29a2.73 2.73 0 0 0-.96 2.1v8.08c0 .73.29 1.429.806 1.944M6.94 1.83a1.24 1.24 0 0 1 .81-.31c.299.002.586.112.81.31l5 4.28a1.26 1.26 0 0 1 .44.95v8.08a1.25 1.25 0 0 1-1.25 1.25H11v-3.75a2.25 2.25 0 0 0-2.25-2.25h-2a2.25 2.25 0 0 0-2.25 2.25v3.75H2.75a1.25 1.25 0 0 1-1.25-1.25v-8.08a1.26 1.26 0 0 1 .44-.95zm2.56 14.56H6v-3.75a.76.76 0 0 1 .75-.75h2a.76.76 0 0 1 .75.75z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHomeLight);
export default ForwardRef;